import { Link } from 'react-router-dom';
import { Calendar, Clock, ArrowRight, BookOpen } from 'lucide-react';
import { POSTS } from './posts';
import { SEO, orgJsonLd } from '../../components/SEO';

export default function BlogList() {
  return (
    <div className="min-h-screen bg-[#FAFAFA]" data-testid="blog-list">
      <SEO
        title="Blog — Grant Writing, Corporate Partnerships & Fundraising Guides"
        description="Practical guides for small nonprofits on grant search, grant writing, corporate partnerships, and fundraising strategy. New posts every week."
        path="/blog"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'Blog',
          name: 'RaiseRoot Blog',
          description: 'Fundraising and grant strategy guides for small nonprofits.',
          publisher: orgJsonLd,
          blogPost: POSTS.map(p => ({
            '@type': 'BlogPosting',
            headline: p.title,
            description: p.description,
            datePublished: p.published,
            author: { '@type': 'Organization', name: 'RaiseRoot' },
            url: `https://raiseroot.co/blog/${p.slug}`,
          })),
        }}
      />

      <section className="pt-28 pb-10 md:pt-32 md:pb-14">
        <div className="max-w-5xl mx-auto px-6">
          <div className="flex items-center gap-2 text-[#00A859] text-sm font-medium tracking-wide uppercase mb-3">
            <BookOpen className="w-4 h-4" />
            RaiseRoot Blog
          </div>
          <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight text-[#0A0A0A] leading-[1.1] mb-4">
            Grants, corporate partnerships,<br />and fundraising, decoded.
          </h1>
          <p className="text-lg text-[#5C6B67] max-w-2xl">
            Practical guides for small nonprofits — no filler, no fluff. Written by fundraisers who&apos;ve been there.
          </p>
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-5xl mx-auto px-6">
          <div className="grid gap-6">
            {POSTS.map((post) => (
              <Link
                key={post.slug}
                to={`/blog/${post.slug}`}
                className="group block bg-white border border-[#E2E8E6] rounded-2xl p-6 md:p-8 hover:border-[#00A859]/40 hover:-translate-y-0.5 transition-all"
                data-testid={`blog-card-${post.slug}`}
              >
                <div className="flex items-center gap-3 mb-3 text-xs text-[#5C6B67]">
                  <span className="bg-[#00A859]/10 text-[#00A859] px-2.5 py-1 rounded-full font-medium">
                    {post.category}
                  </span>
                  <span className="flex items-center gap-1">
                    <Calendar className="w-3.5 h-3.5" />
                    {new Date(post.published).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                  </span>
                  <span className="flex items-center gap-1">
                    <Clock className="w-3.5 h-3.5" />
                    {post.readTime}
                  </span>
                </div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-[#0A0A0A] mb-3 group-hover:text-[#11302A] transition-colors">
                  {post.title}
                </h2>
                <p className="text-[#5C6B67] mb-4">{post.description}</p>
                <span className="inline-flex items-center gap-1 text-sm font-medium text-[#00A859]">
                  Read the guide
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
